import React from 'react';
import { SectionWrapper, GoldDivider } from './Shared';
export const Hook = () => {
  return <SectionWrapper className="bg-prime-dark border-y border-white/5" data-id="element-71">
      <div className="text-center mb-12" data-id="element-72">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-73">
          ¿A dónde se fue ese hombre?
        </h2>
      </div>

      <div className="space-y-8 text-lg md:text-xl text-prime-textMuted leading-relaxed" data-id="element-74">
        <p data-id="element-75">
          ¿Alguna vez te has mirado al espejo y te has preguntado a dónde se fue
          ese hombre lleno de energía y confianza que solías ser?
        </p>
        <p className="text-white font-medium text-xl md:text-2xl border-l-2 border-prime-gold pl-6" data-id="element-76">
          No eres el único.
        </p>
        <p data-id="element-77">
          En los últimos 10 años, los niveles de testosterona en hombres
          americanos han caído a mínimos históricos. La industria del
          "bienestar" quiere que creas que la única solución es{' '}
          <span className="text-prime-gold" data-id="element-78">
            inyectarte hormonas de por vida
          </span>{' '}
          o resignarte a la 'barriga de papá'.
        </p>
        <p className="font-serif text-2xl md:text-3xl text-white text-center pt-8 italic" data-id="element-79">
          Pero hay un camino diferente.
        </p>
      </div>
      <GoldDivider data-id="element-80" />
    </SectionWrapper>;
};